import React from 'react';
import './Privacy.css';
import Header from './Header';
import Footer from './Footer';

const Privacy = () => {
  return (
    <div className="privacy-page">
      <Header />
      <section className="privacy-section">
        <div className="container">
          <h1 className="section-title privacy-title">Privacy Policy</h1>
          
          <div className="privacy-content">
            <p className="privacy-updated">Last updated: December 2025</p>

            <h2 className="privacy-heading">1. Introduction</h2>
            <p className="privacy-text">
              Welcome to Nanocaps. This Privacy Policy explains how Currahee Limited ("we," "our," or "us") collects, uses, and protects your personal information when you use our website and services.
            </p>
            <p className="privacy-text">
              By using our website or providing your information to us, you agree to the collection and use of information in accordance with this policy.
            </p>

            <h2 className="privacy-heading">2. Information We Collect</h2>
            <p className="privacy-text">
              We collect information necessary to provide our system intelligence and integration mapping services:
            </p>
            <p className="privacy-text">
              <strong>Account Information:</strong> Email address and name when you create an account.
            </p>
            <p className="privacy-text">
              <strong>System Data:</strong> Documents, architecture diagrams, system inventories, and workflow information you upload to our platform.
            </p>
            <p className="privacy-text">
              <strong>Usage Data:</strong> Information about how you interact with our services to improve the platform.
            </p>
            <p className="privacy-text">
              We use cookies and similar technologies to enhance your experience and analyze platform usage.
            </p>

            <h2 className="privacy-heading">3. How We Use Your Information</h2>
            <p className="privacy-text">
              We use the information we collect for the following purposes:
            </p>
            <ul className="privacy-list">
              <li>To provide and improve our AI-powered system intelligence services</li>
              <li>To analyze your system architecture and provide integration insights</li>
              <li>To communicate with you about product updates and features</li>
              <li>To ensure the security and integrity of our services</li>
              <li>To respond to your inquiries or requests</li>
            </ul>
            <p className="privacy-text">
              You can opt out of marketing communications at any time by following the unsubscribe instructions in our emails or by contacting us directly at pierre@nanocaps.ai.
            </p>

            <h2 className="privacy-heading">4. Data Sharing and Disclosure</h2>
            <p className="privacy-text">
              We do not sell your personal information. We may share your data in the following circumstances:
            </p>
            <p className="privacy-text">
              <strong>Service Providers:</strong> Third-party services that help us operate our platform (e.g., cloud hosting, analytics).
            </p>
            <p className="privacy-text">
              <strong>Legal Requirements:</strong> When required by law or to protect our rights and safety.
            </p>
            <p className="privacy-text">
              Our AI models process your system data to provide insights and recommendations, but we implement measures to protect your privacy and data security.
            </p>

            <h2 className="privacy-heading">5. Data Retention</h2>
            <p className="privacy-text">
              We retain your account information and system data for as long as your account is active. If you delete your account, we will remove your personal data within 30 days, except where we're required to retain it for legal purposes.
            </p>

            <h2 className="privacy-heading">6. Your Rights</h2>
            <p className="privacy-text">
              You have the following rights regarding your personal information:
            </p>
            <ul className="privacy-list">
              <li><strong>Access:</strong> You can request a copy of the personal information we hold about you.</li>
              <li><strong>Deletion:</strong> You can request that we delete your personal information at any time.</li>
              <li><strong>Correction:</strong> You can update or correct your personal information.</li>
              <li><strong>Data Portability:</strong> You can request a copy of your data in a portable format.</li>
              <li><strong>Opt-out:</strong> You can opt out of marketing communications at any time.</li>
            </ul>
            <p className="privacy-text">
              To exercise any of these rights, please contact us at pierre@nanocaps.ai.
            </p>

            <h2 className="privacy-heading">7. Data Security</h2>
            <p className="privacy-text">
              We implement industry-standard security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. This includes encryption of data in transit and at rest, regular security assessments, and access controls.
            </p>
            <p className="privacy-text">
              However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2 className="privacy-heading">8. Changes to This Privacy Policy</h2>
            <p className="privacy-text">
              We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the new Privacy Policy on this page and updating the "Last updated" date. For material changes, we will provide additional notice via email.
            </p>
            <p className="privacy-text">
              You are advised to review this Privacy Policy periodically for any changes.
            </p>

            <h2 className="privacy-heading">9. Contact Us</h2>
            <p className="privacy-text">
              If you have any questions about this Privacy Policy or our data practices, please contact us:
            </p>
            <p className="privacy-text">
              <strong>Currahee Limited</strong><br />
              86-90 Paul Street<br />
              London, England<br />
              United Kingdom, EC2A 4NE<br />
              <br />
              Email: pierre@nanocaps.ai
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Privacy;

